var _defs, _g, _g2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0, .st1 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #647f94;\r\n      }\r\n\r\n      .st1 {\r\n        font-family: MongolianBaiti, 'Mongolian Baiti';\r\n        font-size: 55.5px;\r\n      }\r\n\r\n      .st1, .st3 {\r\n        fill: #65b794;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.6,89.6H3.5c-1.8,0-3.3-1.5-3.3-3.3V5.5c-.1-1.8,1.4-3.3,3.3-3.3h48.3c1.8,0,3.3,1.5,3.3,3.3s-1.5,3.3-3.3,3.3H6.8v74.1h72.8c2.6,0,4.7-2.1,4.7-4.7v-16.1c0-1.8,1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3v16.1c0,6.3-5.1,11.3-11.3,11.3h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(29.3 65.8) rotate(-.6) scale(2.2 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.9,2.2h24.1c.9,0,1.6,1.5,1.6,3.3s-.8,3.3-1.6,3.3h-22.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.7,5.5v35.5c0,.9-1.5,1.6-3.3,1.6s-3.3-.8-3.3-1.6V7.2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.eee5f6ac1dcbc4055bf1016b874caf16.svg";
export { ForwardRef as ReactComponent };